import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBrackets2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="brackets-2"><path d="M8.25 3.75H4.75V12M15.75 20.25H19.25V12M4.75 12H2.75M4.75 12V20.25H8.25M19.25 12H21.25M19.25 12V3.75H15.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconBrackets2;
